import { Popover } from '@mui/material'
import type { FC } from 'react'
import React, { useCallback, useRef } from 'react'
import { cx } from 'src/utils/cx'
import { track } from 'src/utils/tracker'
import type { HelpPopoverProps } from './HelpIcon'

/**
 * @deprecated use UITooltipTriggerWrapper instead
 * @param param0
 * @returns
 */
export const HelpPopover: FC<HelpPopoverProps> = ({
  children,
  scene,
  className,
  trigger,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement>()

  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  function open(el: HTMLElement) {
    setAnchorEl(el)
  }

  function close() {
    setAnchorEl(undefined)
  }

  const onLeave = useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current)
    }
    timer.current = setTimeout(close, 100)
  }, [])

  return (
    <>
      <div
        className={cx('flex items-center justify-center', className)}
        onMouseOver={e => {
          open(e.currentTarget)
          track('help_icon_show', {
            scene,
          })
        }}
        onMouseLeave={onLeave}
      >
        {trigger}
      </div>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        className="pointer-events-none"
        onClose={close}
        disableRestoreFocus
        disableAutoFocus
        slotProps={{
          paper: {
            className: 'pointer-events-auto',
            onMouseEnter: () => clearTimeout(timer.current),
            onMouseLeave: close,
          },
        }}
      >
        {children}
      </Popover>
    </>
  )
}
